import { fetchSiteClassification } from '../api/fetchSiteClassification';
import {
  setCachedClassification,
  getCachedClassification,
} from '../storage/classificationLRU';

export const getClassification = async (hostname: string) => {
  const cachedClassification = getCachedClassification(hostname);
  if (cachedClassification) {
    return cachedClassification;
  }

  const apiClassification = await fetchSiteClassification(hostname);
  if (apiClassification) {
    setCachedClassification(hostname, apiClassification);
  }

  return apiClassification;
};
